import { observable, action, flow, makeObservable } from "mobx";
import ApiBasedStore from "./ApiBasedStore";
import beautifyApi from "../api/beautifyApi";

export default class BeautifyStore extends ApiBasedStore {
  beautifyApi = beautifyApi;
  reviews = [];
  totalReviews = 0;
  currentPage = 0;
  pageSize = 10;
  filterScore = null;

  constructor(rootStore) {
    super(rootStore);
    makeObservable(this, {
      reviews: observable,
      totalReviews: observable,
      currentPage: observable,
      pageSize: observable,
      filterScore: observable,
      setCurrentPage: action,
      setPageSize: action,
      setFilterScore: action,
    });
  }

  setCurrentPage = (page) => {
    this.currentPage = page;
  };

  setPageSize = (size) => {
    this.pageSize = size;
  };

  setFilterScore = (score) => {
    this.filterScore = score;
    this.currentPage = 0; // Reset to first page when filter changes
  };

  fetchReviews = flow(function* () {
    this.startRequest();
    try {
      const params = {
        page: this.currentPage,
        limit: this.pageSize,
      };
      
      if (this.filterScore) {
        params.review_score = this.filterScore;
      }

      const result = yield this.beautifyApi.getReviews(params);
      this.reviews = result.reviews || [];
      this.totalReviews = result.total || 0;
    } catch (e) {
      this.onError(e);
    } finally {
      this.endRequest();
    }
  });
}